import React, { useState } from "react";
import VersionModal from "./versionModal";
import "./versionSwitch.css";

const VersionSwitch = ({ isSidebarOpen }) => {
  const [modalStatus, setModalStatus] = useState(false);

  return (
    <>
      <div
        style={{
          display: "flex",
          alignSelf: "center",
          marginTop: "45vh",
          flexDirection: isSidebarOpen ? "row" : "column",
          width: isSidebarOpen ? "auto" : 50,
        }}
        className="versionButtons"
      >
        {/* {isSidebarOpen && ( */}

        {/* )} */}
        {isSidebarOpen && (
          <div
            className="versionSingleButton"
            style={{
              backgroundColor: "#fff",
              color: "#000",
              "@media (max-width:500px)": {
                padding: "5px",
              },
            }}
            onClick={() => setModalStatus(!modalStatus)}
          >
            V1
          </div>
        )}
        <div
          className="versionSingleButton"
          style={{
            backgroundColor: "#413AE2",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: isSidebarOpen ? "20px !important" : "auto",
            "@media (max-width:500px)": {
              padding: "5px",
            },
          }}
          // onClick={() => setModalStatus(!modalStatus)}
        >
          V1.1
        </div>
        {isSidebarOpen && (
          <a
            href="https://staking.phoenixdao.io/v2"
            style={{ textDecoration: "none" }}
          >
            <div
              className="versionSingleButton"
              style={{
                backgroundColor: "#fff",
                color: "#000",
                "@media (max-width:500px)": {
                  padding: "5px",
                },
              }}
              // onClick={() => setModalStatus(!modalStatus)}
            >
              V2
            </div>
          </a>
        )}
      </div>
      <VersionModal status={modalStatus} setStatus={setModalStatus} />
    </>
  );
};

export default VersionSwitch;
